import React, { useContext, useState } from 'react';
import { SxProps, Box, AppBar, IconButton, Menu, MenuItem, Toolbar,  Theme, Chip } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import DashboardList from "../dashboardList/DashboardList";
import FavouriteDashboard from './FavouriteDashboard';
import PrimaryDashboard from './PrimaryDashboard';
import FiltersDashboard from './FiltersDashboard';
import PrintDashboard from './PrintDashboard';
import RefreshDashboard from './RefreshDashboard';
import { DashboardFiltersContext } from '../filters/DashboardFiltersContext';
import { UIContext } from '../../../../context/UIContext';
import { DashboardContext } from '../../DashboardContext';


const KebabDashboard = () =>
  <Box sx={{ flex: 1 }}>
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <MoreVert />
    </Box>
  </Box>

interface DashboardTopMenuProps {
  sxProp?: SxProps<Theme>;
  printRef: React.RefObject<HTMLDivElement>;
}

const DashboardTopMenu = ({ sxProp, printRef }: DashboardTopMenuProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openList, setOpenList] = useState(false);
  const { currentDashboard } = useContext(DashboardContext)
  const { chips } = useContext(DashboardFiltersContext);
  const { isMobile, isTablet, isLargeDevice } = useContext(UIContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();

  return (
      <AppBar position="static" color="transparent" sx={{ ...sxProp, }} elevation={0}>
        <Toolbar disableGutters sx={{
          display: 'flex',
          paddingX: '8px',
          flexDirection: { xs: 'column', md: 'column', lg: 'row' },
        }}>
          <DashboardList sx={{ marginLeft: 'auto', backgroundColor: 'background.paper', minWidth: { xs: '100%', md: '100%', lg: '25%' } }} />
          {isLargeDevice &&
            <Box sx={{
              minWidth: { lg: '64%', xl: 'fit-content' },
              padding: '1px', flexGrow: 1,
              display: { xs: 'none', md: 'none', lg: 'flex' },
              justifyContent: 'space-between',
              marginRight: 'auto',
              marginLeft: '4px'
            }}>
              <Box>
                <PrimaryDashboard key='primary-dashboard'/>
                <FavouriteDashboard key='favourite-dashboard' />
              </Box>
              <Box>
                <FiltersDashboard key='filters-dashboard' />
                <PrintDashboard key='print-dashboard-mobile' printRef={printRef} />
                <RefreshDashboard key='refresh-dashboard' />
              </Box>
            </Box>
          }
          {!isLargeDevice &&
            <Box
              sx={{
                display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none' },
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              <RefreshDashboard />
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  if (isMobile || isTablet) {
                    setOpenModal(true)
                  } else {
                    setAnchorEl(event.currentTarget)
                    setOpenList(true)
                  }
                }}
                color="inherit"
              >
                <KebabDashboard />
              </IconButton>
            </Box>
          }
          <Menu
            id="menu-appbar"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={openList}
            onClose={() => {
              setAnchorEl(null)
              setOpenList(false)
            }}
            anchorEl={anchorEl}
          >
            {[
              <PrimaryDashboard key='primary-dashboard' />,
              <FavouriteDashboard key='favourite-dashboard' />,
              <FiltersDashboard key='filters-dashboard' />,
              <PrintDashboard key='print-dashboard' printRef={printRef} />
            ].map((page) => (
              <MenuItem onClick={() => setOpenList(false)} key={`menu-item-${page.key}`}>
                {page}
              </MenuItem>
            ))}
          </Menu>
        </Toolbar>
        {chips &&
          <Toolbar
            variant='dense'
            sx={{
              paddingX: '8px',
              pl: { sm: 2 },
              pr: { sm: 2 }
            }}
          >
            <div
              style={{ flex: '1 1 100%', display: 'inline-block', marginTop: "12px", marginBottom: "12px" }}
            >
              <div style={{ flex: '1 1 100%', display: 'inline-block' }}>
{chips.map((chip) => (
  <Chip
    key={`chip-${chip.label}`}
    variant="filled"
    label={chip.label}
    onClick={chip.onClick}
    onDelete={chip.onDelete}
    sx={{
      marginRight: '8px',
      backgroundColor:
        chip.labelType === 'periodCompare'
          ? theme?.palette?.warning['190p']
          : theme.palette.info['190p'],
      '& .MuiChip-label': {
        color: chip.labelType === 'periodCompare' ? theme.palette.warning['160p'] : theme.palette.info['160p']
      }
    }}
  />
))}
              </div>
            </div>
          </Toolbar>
        }
      </AppBar>
  );
}

export default DashboardTopMenu;
